import {claimPopup,releasePopup,popupAvailable,suspendPopupParents} from './popupDisplay'
// 保留Ant原生回调、异步确认、update/destroy；只延后尚未展示的提示。
export function installPopupFeedback(modal:any,context:()=>string){
  for(const name of ['info','success','error','warning','warn','confirm']){
    const original=modal[name];if(typeof original!=='function')continue
    modal[name]=(value:any)=>{
      const owner={},stamp=context();let options={...value},instance:any,disposed=false,afterClose:(()=>void)|undefined,timer:ReturnType<typeof setTimeout>|undefined
      const destroy=()=>{disposed=true;if(timer)clearTimeout(timer);if(instance)instance.destroy()}
      const show=()=>{
        if(disposed || stamp!==context()){destroy();return}
        let restore:(()=>void)|undefined
        if(!claimPopup(owner)){restore=suspendPopupParents(owner);if(!restore){timer=setTimeout(show,150);return}}
        afterClose=()=>{releasePopup(owner);restore?.();options.afterClose?.()}
        try{instance=original.call(modal,{...options,afterClose})}catch(error){restore?.();releasePopup(owner);throw error}
      }
      show()
      return {destroy,update:(next:any)=>{options=typeof next==='function'?next(options):{...options,...next};if(instance)instance.update({...options,afterClose})}}
    }
  }
  // 监听手动弹窗的关闭边界，自动提示需等待其退出动画与间隔。
  const owner={};setInterval(()=>popupAvailable(owner),250)
}
